import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { date } from 'redux-form-validators';

import { DATE_FORMAT_REDUXFORM } from '../../constants';

import InputFieldComponent from './InputFieldComponent';

/**
 * The format of the date return will be 'yyyy-mm-dd', default format défine by HTML5
 */
class DateInputFieldComponent extends React.Component {
    validateDefault = () => [
        date({
            format: DATE_FORMAT_REDUXFORM,
            msg: this.props.i18nFeatureForm.DATE_FORMAT_INVALID,
            ymd: this.props.i18nFeatureForm.REDUX_FORM_FORMAT_YMD_OPTION,
            allowBlank: !this.props.isRequired
        }),
        date({
            msg: this.props.i18nFeatureForm.DATE_MUSTBEINFUTURE,
            '>=': this.props.mustBeDateFuture ? 'today' : '',
            allowBlank: true
        }),
        date({
            msg: this.props.i18nFeatureForm.DATE_MUSTBEINPAST,
            '<=': this.props.mustBeDatePast ? 'today' : '',
            allowBlank: true
        })
    ];

    render() {
        const { validate } = this.props;

        return (
            <InputFieldComponent
                {...this.props}
                type="date"
                validate={validate ? validate : this.validateDefault()}
            />
        );
    }
}

// See proptypes in ./InputFieldComponent.js for global Field props
DateInputFieldComponent.propTypes = {
    mustBeDateFuture: PropTypes.bool,
    mustBeDatePast: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        i18nFeatureForm: state.i18n.feature.form
    };
};

export default connect(mapStateToProps)(DateInputFieldComponent);



// WEBPACK FOOTER //
// ./src/components/form/DateInputFieldComponent.js